

import { Route, Routes } from "react-router-dom";
import Wrap from "../../hoc/Wrap";
import TwoFAVerify from "./TwoFAVerify";
import TwoFactorAuth from "./TwoFactorAuth";
const TwoFAVerifyContainer = () => {

  return (
    <Wrap>  
      <Routes>
      <Route path="/" element={<TwoFactorAuth />} />
      <Route path="/:userId" element={<TwoFAVerify />} />
      </Routes>
    </Wrap>
  );
};






export default TwoFAVerifyContainer;
